import { LEVELS } from "@package/map";

import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

import { PROVINCES } from "Constants/App";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changeLevel, changeZone, toggleVisibility as toggleZones } from "Redux/zonesSlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";

export default function Zone() {
  const dispatch = useAppDispatch();

  const { level, zone, visible } = useAppSelector((state) => state.zones);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleLevel = (event: React.MouseEvent<HTMLElement>, newMode: any) => {
    if (newMode !== null) {
      dispatch(changeLevel(Number(newMode)));
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <FormControl style={{ width: "120px" }}>
          <InputLabel id="demo-simple-select-label">استان</InputLabel>
          <Select
            value={zone}
            label="استان"
            sx={{ width: "120px" }}
            onChange={(e) => dispatch(changeZone(Number(e.target.value)))}
          >
            {PROVINCES.map((i) => (
              <MenuItem value={i.zoneId}>{i.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <ToggleButtonGroup value={level} onChange={handleLevel} exclusive aria-label="level-group">
          {LEVELS.map((l, index) => (
            <ToggleButton
              value={l.id}
              aria-label={`level-${index}`}
              style={{
                maxWidth: "90px",
                height: "56px",
                backgroundColor: level === l.id ? "#4754CA" : "",
                color: level === l.id ? "#fff" : "",
              }}
            >
              {l.name}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={() => dispatch(toggleZones())} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}

// import { LEVELS } from "@package/map";

// import {
//   Card,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Stack,
//   Typography,
//   Switch,
//   ToggleButtonGroup,
//   ToggleButton,
// } from "@mui/material";

// import { PROVINCES } from "Constants/App";

// import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
// import { changeLevel, changeZone, toggleVisibility as toggleZones } from "Redux/zonesSlice";
// import { useEffect } from "react";
// import axios from "axios"; // اضافه کردن axios

// export default function Zone() {
//   const dispatch = useAppDispatch();

//   const { level, zone, visible } = useAppSelector((state) => state.zones);
//   const label = { inputProps: { "aria-label": "Switch demo" } };

//   const handleLevel = (event: React.MouseEvent<HTMLElement>, newMode: any) => {
//     if (newMode !== null) {
//       dispatch(changeLevel(Number(newMode)));
//     }
//   };

//   // اضافه کردن useEffect برای ارسال درخواست
//   useEffect(() => {
//     if (visible) {
//       // درخواست GET با ارسال zone انتخاب شده
//       axios
//         .get(`https://gis.demo.kashantejarat.ir/zone-points/50`)
//         .then((response) => {
//           console.log("داده‌های دریافت شده:", response.data);
//         })
//         .catch((error) => {
//           console.error("خطا در دریافت داده‌ها:", error);
//         });
//     }
//   }, [visible, zone]); // وابستگی‌ها: هر بار visible یا zone تغییر کند، این بلاک چک می‌شود

//   return (
//     <Card sx={{ p: 1.5 }}>
//       <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
//         <FormControl style={{ width: "120px" }}>
//           <InputLabel id="demo-simple-select-label">استان</InputLabel>
//           <Select
//             value={zone}
//             label="استان"
//             sx={{ width: "120px" }}
//             onChange={(e) => dispatch(changeZone(Number(e.target.value)))}
//           >
//             {PROVINCES.map((i, index) => (
//               <MenuItem key={index} value={i.zoneId}>
//                 {i.name}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         <ToggleButtonGroup value={level} onChange={handleLevel} exclusive aria-label="level-group">
//           {LEVELS.map((l, index) => (
//             <ToggleButton
//               key={index}
//               value={l.id}
//               aria-label={`level-${index}`}
//               style={{
//                 maxWidth: "90px",
//                 height: "56px",
//                 backgroundColor: level === l.id ? "#4754CA" : "",
//                 color: level === l.id ? "#fff" : "",
//               }}
//             >
//               {l.name}
//             </ToggleButton>
//           ))}
//         </ToggleButtonGroup>
//         <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
//           <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
//           <Switch {...label} onChange={() => dispatch(toggleZones())} checked={visible} />
//         </Stack>
//       </Stack>
//     </Card>
//   );
// }
